var React = require('react');

function Bandage (props) {
    return React.createElement("svg",props,React.createElement("g",{"clipPath":"url(#a)","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M14 12v.01M10 12v.01M12 10v.01M12 14v.01M4.5 12.5l8-8a4.95 4.95 0 0 1 7 7l-8 8a4.95 4.95 0 1 1-7-7z"})));
}

Bandage.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Bandage;

Bandage.default = Bandage;
